import React, { useContext, useEffect, useState } from "react"
import { toast } from "react-toastify"
import Container from "../atoms/Container"
import NotebookRemoveConfirm from "../notebook/NotebookRemoveConfirm"
import { notebookContext } from "../providers/notebook.provider"
import { deleteNotebookEntry } from "../utils/firestore.utils"
import { networkAwareMessage } from "../utils/network.utils"

// "Togli dal quaderno" dalla voce aperta di un esercizio: il foglio che
// chiede conferma (NotebookRemoveConfirm). Tolta la voce, la pagina
// dell'esercizio sotto si chiude da sola, perché non c'è più niente da
// mostrare.
export function RemoveNotebookEntryModal({ closeModal, entryID }) {
	const { getEntry } = useContext(notebookContext)
	const [isRemoving, setRemovingState] = useState(false)
	const entry = getEntry(entryID)

	// tolta intanto da un altro telefono: non c'è più niente da chiedere
	useEffect(() => {
		if (!entry) closeModal()
	}, [entry, closeModal])
	if (!entry) return null

	const remove = async () => {
		setRemovingState(true)
		try {
			await deleteNotebookEntry(entryID)
			closeModal()
		} catch (error) {
			const message = networkAwareMessage(error, "Non sono riuscito a toglierlo dal quaderno")
			toast.error(message, { toastId: message, position: "top-center" })
			setRemovingState(false)
		}
	}

	return (
		<Container>
			<NotebookRemoveConfirm entry={entry} busy={isRemoving} onConfirm={remove} onCancel={closeModal} />
		</Container>
	)
}

export default RemoveNotebookEntryModal
